import produce from 'immer';

import * as constants from './constants';
import { DictationAction, DictationStore } from './types';

const initialState: DictationStore = {
    scaling: 1,
};

const dictation = (state: DictationStore = initialState, action: DictationAction) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.SET_PROBLEM_SCALING:
                draft.scaling = action.scaling;
                break;

            default:
                break;
        }
    });
};

export default dictation;
